<template>
  <section class="resources-search-result">
      <div v-if="!keywords">
        <h2>{{ resourcesSearchResult.title }}</h2>
        <div class="resources-description" v-html="resourcesSearchResult.content"></div>
      </div>
      <div v-else>
        <h2>{{ resourcesSearchResult.searchTitle }}</h2>
        <div v-html="resourcesSearchResult.searchDescription"></div>
      </div>

      <div class="search">
        <div v-if="!searchResult">
          <h4>{{ resourcesSearchResult.search.title }}</h4>
          <div class="search__description" v-html="resourcesSearchResult.search.description"></div>
        </div>
        <SearchSection
          :input="{placeholder: resourcesSearchResult.search.input.placeholder, class: 'resources-search-result__search', autocomplete: false}"
          :button="{
            text: keywords ? 'Search again' : resourcesSearchResult.search.searchButton.text,
            class: 'resources-search-result__search-btn ms-lg-4 mt-3 mt-lg-0',
          }"
          @search="onSearchClick"
        />
      </div>

      <loader-spinner :loading="isLoading" :color="'green'" :size="'30px'" class="position-absolute spinner"></loader-spinner>
      <div v-show="!isLoading">
        <div v-if="keywords" class="mt-5 d-flex">
          <h3 class="me-2">{{ resourcesSearchResult.searchResults }}</h3>
          <h3>{{ keywords }}</h3>
        </div>
        
        <div
          v-if="searchResult && searchResult.result.length !== 0"
          v-for="result in searchResult.result"
          class="resources-search-result__result-item"
          :key="result.id"
          >
            <h4>{{ result.title }}</h4>
            <ButtonTransparent hyperlink :href="result.url" text="Read more" class="result-item-btn" />
        </div>
      </div>

      <div
        class="pagination-wrapper py-5 d-flex justify-content-center"
        v-if="searchResult && searchResult.pageCount > 1"
      >
        <paginate
          v-model="searchResult.currentPage"
          :page-count="searchResult.pageCount"
          :page-range="5"
          :margin-pages="3"
          :click-handler="clickCallback"
          prev-text="Previous"
          next-text="Next"
          prev-class="btn-prev"
          next-class="btn-next"
          active-class="btn-active"
        />
      </div>
  </section>
  
</template>

<script setup>
import { ref, watch } from 'vue';
import useLoadData from "@/composables/useLoadData";
import LoaderSpinner from 'vue-spinner/src/ClipLoader.vue'
import {useRouter} from "vue-router";
import {handlePaginateClick} from "@/utils/utils";
import Paginate from 'vuejs-paginate-next';
import SearchSection from "@/components/common/SearchSection";
import ButtonTransparent from "@/components/common/ButtonTransparent";

const props = defineProps({
  resourcesSearchResult: {
    title: String,
    content: HTMLElement,
    searchResults: String,
    searchTitle: String,
    searchDescription: String,
    search: {
      title: String,
      description: String,
      input: {
        placeholder: String,
      },
      searchButton: {
        text: String,
      },
      url: String,
    }
  }
})

const router = useRouter();
const keywords = ref('');
const page = ref(router.currentRoute.value.query.id || 1)
const options = ref({method: 'get', params: { page: page.value }});

const {data: searchResult, fetchData: fetchResult, isLoading} = useLoadData(props.resourcesSearchResult.search.url, options.value)

const clickCallback = (newValue) => {
    handlePaginateClick(options, newValue, router)
    fetchResult()
  }

const onSearchClick = (searchValue) => {
  fetchResult({ params: { keywords: searchValue} })
  keywords.value = searchValue;
}

watch(searchResult, (newValue) => {
  if (newValue.result) {
    const widgetContainer = document.getElementById('widget-container');

    if (widgetContainer) {
      widgetContainer.style.display = 'none';
    }
  }
})
</script>